/* @flow */

import type { JSON, JSONObject } from 'common/types';

export function value(json: JSON): JSON {
  return json;
}

export function object(jsonObject: JSONObject) {
  return jsonObject;
}
